<template>
  <div class="w100">
    <div class="form pt-3">
      <div class="tabs-border mt-0 mb-2 flex flex-row align-items-end">
        <div
          v-for="(tab, idx) in tabs"
          :key="idx"
          class="tab"
          :class="{ active: activeTab == tab }"
          @click="activeTab = tab"
        >
          {{ tab }}

          <span
            style="color: red"
            v-if="
              inputs.filter(
                (i) => !i.isHide && (!i.tab || i.tab == tab) && i.required,
              ).length > 0
            "
          >
            *
          </span>
        </div>
      </div>
      <div class="form-content" :style="{ overflow: overflow || 'auto' }">
        <div
          v-for="input in inputs.filter(
            (i) => !i.isHide && (!i.tab || i.tab == activeTab),
          )"
          :key="input.key"
          style="display: contents"
        >
          <div
            :key="input.key"
            v-if="input.type == 'title'"
            class="d-block w-100"
          >
            <p class="bold my-2 px-2">
              {{ input.title }}
              <span v-if="input.required" class="text-danger">*</span>
            </p>
          </div>
          <div
            :key="input.key + '11'"
            v-else-if="input.type == 'hr'"
            class="d-block w-100"
          >
            <hr class="mb-2" />
          </div>
          <div
            v-else
            class="input-field flex-column"
            :name="input.key"
            :type="input.type"
            :key="input.key + '12'"
            :style="{ width: 'calc(' + (input.width || '100%') + ' - 10px)' }"
          >
            <label :class="input.className">
              {{ input.title }}
              <span v-if="input.required" class="text-danger">*</span></label
            >
            <div v-if="input.prefix" class="prefix">{{ input.prefix }}</div>
            <div v-if="input.type === 'checkbox-list'" class="pt-4 w-100">
              <div style="max-height: 300px; overflow: auto">
                <div
                  :key="item.id"
                  v-for="(item, idx) in input.selectList"
                  class="p-2"
                >
                  <check-box
                    @change="
                      output[input.key].indexOf(item.id) > -1
                        ? output[input.key].splice(idx, 1)
                        : output[input.key].push(item.id)
                      runUpdate(input)
                    "
                    :value="output[input.key].indexOf(item.id) > -1"
                    class="font-14"
                    ref="inputs"
                    :title="item.name"
                    :disabled="input.disabled"
                  />
                </div>
              </div>
            </div>
            <div v-else-if="input.type === 'multi-select'">
              <auto-complete
                v-model="output[input.key]"
                :multi="true"
                :required="input.required"
                :disabled="input.disabled"
                ref="inputs"
                :key="input.key"
                :class="{
                  error: input.required && !output[input.key],
                }"
                class="w-100"
                @changeOption="runUpdate(input)"
                @input="
                  output[input.key] = $event
                "
                :list="input.selectList"
                :searchFunction="input.searchFunction"
                :tag="true"
              />
            </div>
            <multi-select-input
              v-else-if="input.type === 'multi'"
              v-model="output[input.key]"
              :disabled="input.disabled"
              :list="input.selectList"
              :searchFunction="input.searchFunction"
              :placeholder="input.title"
              ref="inputs"
              @change="runUpdate(input)"
            />
            <auto-complete
              v-model="output[input.key]"
              v-else-if="input.type === 'select-search'"
              :disabled="input.disabled"
              :required="input.required"
              ref="inputs"
              class="w-100"
              @changeOption="runUpdate(input)"
              :placeholder="input.title"
              :list="input.selectList"
              :searchFunction="input.searchFunction"
              :tag="true"
            />
            <select
              :id="getKey()"
              v-else-if="input.type === 'select'"
              :required="input.required"
              v-model="output[input.key]"
              :disabled="input.disabled"
              class="form-control"
              :class="{
                error: input.required && !output[input.key],
              }"
              @input="
                output[input.key] = $event.target.value
                runUpdate(input)
              "
              ref="inputs"
            >
              <option
                v-for="item in input.selectList"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
            <div
              :id="getKey()"
              v-else-if="input.type === 'checkbox'"
              class="form-control"
            >
              <check-box
                @input="runUpdate(input)"
                v-model="output[input.key]"
                :disabled="input.disabled"
                class="font-14"
                ref="inputs"
              />
            </div>
            <div
              :id="getKey()"
              v-else-if="input.type === 'table'"
              class="table table-bordered mt-4 box"
            >
              <div style="overflow: auto">
                <table>
                  <thead>
                    <tr>
                      <th
                        v-for="(col, idx) in input.columns"
                        :key="idx"
                        :class="col.className"
                        :style="{
                          width: col.width,
                          textAlign:
                            col.className === 'text-right' ? 'right' : 'left',
                        }"
                      >
                        {{ col.title }}
                      </th>
                      <th
                        style="width: 30px"
                        v-if="
                          input.tableConfig &&
                          input.tableConfig.allowDelete === true
                        "
                      ></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(row, rowIndex) in output[input.key]"
                      :key="rowIndex"
                    >
                      <td
                        v-for="(col, colIndex) in input.columns"
                        :key="colIndex"
                        class="p-1"
                        :style="{
                          width: col.width,
                          textAlign:
                            col.className === 'text-right' ? 'right' : 'left',
                        }"
                      >
                        <money-input
                          v-if="col.type == 'money'"
                          class="form-control p-1 form-control-sm"
                          :style="{
                            width: col.width || '100%',
                            textAlign:
                              col.className === 'text-right' ? 'right' : 'left',
                          }"
                          v-model="row[col.id]"
                          :disabled="col.disabled"
                        />
                        <money-input
                          v-else-if="col.type == 'quantity'"
                          class="form-control p-1 form-control-sm"
                          :style="{
                            width: col.width || '100%',
                            height: '30px',
                            textAlign:
                              col.className === 'text-right' ? 'right' : 'left',
                          }"
                          v-model="row[col.id]"
                          :disabled="col.disabled"
                          :max="row.maxQuantity"
                        />
                        <select
                          v-else-if="col.type == 'select'"
                          class="form-control p-1 form-control-sm"
                          :style="{
                            width: col.width || '100%',
                            height: '30px',
                            textAlign:
                              col.className === 'text-right' ? 'right' : 'left',
                          }"
                          v-model="row[col.id]"
                          :disabled="col.disabled"
                        >
                          <option
                            v-for="o in col.options"
                            :key="o.id || o"
                            :value="o.id || o"
                          >
                            {{ o.name || o }}
                          </option>
                        </select>
                        <input
                          v-else
                          class="form-control p-1 form-control-sm"
                          :style="{
                            width: col.width || '100%',
                            height: '30px',
                            textAlign:
                              col.className === 'text-right' ? 'right' : 'left',
                          }"
                          v-model="row[col.id]"
                          @input="runUpdate(input)"
                          :disabled="col.disabled"
                        />
                      </td>
                      <td class="p-1">
                        <i
                          class="fa fa-times text-danger pointer"
                          v-if="
                            input.tableConfig &&
                            input.tableConfig.allowDelete === true
                          "
                          @click="
                            output[input.key].splice(rowIndex, 1)
                            runUpdate(input)
                          "
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p
                class="text-primary pointer p-2 text-right bold"
                v-if="!input.tableConfig || input.tableConfig.allowNew === true"
                @click="
                  output[input.key] = output[input.key] || []
                  output[input.key].push({})
                  runUpdate(input)
                "
              >
                <i class="fa fa-plus" />
                Thêm dòng mới
              </p>
            </div>
            <div
              :id="getKey()"
              v-else-if="input.type === 'switch'"
              class="form-control"
            >
              <switch-input
                @input="runUpdate(input)"
                v-model="output[input.key]"
                class="font-14 mr-2"
                ref="inputs"
              />
            </div>
            <div
              :id="getKey()"
              v-else-if="input.type === 'options'"
              class="form-control"
            >
              <options
                @input="runUpdate(input)"
                :list="input.selectList"
                v-model="output[input.key]"
                ref="inputs"
              />
            </div>
            <textarea
              :id="getKey()"
              v-else-if="input.type === 'textarea'"
              class="form-control"
              :type="input.type || 'text'"
              :placeholder="input.title"
              :required="input.required"
              :value="output[input.key]"
              @input="
                (e) => {
                  output[input.key] = applyFormat(e.target.value, input)
                  runUpdate(input)
                }
              "
              :rows="input.rows || 5"
              :disabled="input.disabled"
              :class="{
                error: input.required && !output[input.key],
              }"
              ref="inputs"
              :style="{ height: input.height || 'auto' }"
            />
            <div v-else-if="input.type === 'html'" style="width: 100%">
              <br />
              <ClassicEditor
                :editorId="'edit-' + input.key"
                @input="runUpdate(input)"
                v-model="output[input.key]"
                hideHtml
                width="100%"
                :ref="'edit-' + input.key"
              />
            </div>

            <date-picker
              v-else-if="input.type == 'date-range'"
              class="w100"
              :id="getKey()"
              :class="{
                error2: input.required && !output[input.key],
              }"
              :style="{ width: input.width }"
              :required="input.required"
              v-model="output[input.key]"
              range
              :shortcuts="
                input.shortcuts ||
                (input.isFuture ? $shortcutDateRangeFuture : $shortcutDateRange)
              "
              @input="runUpdate(input)"
            />
            <date-picker
              v-else-if="input.type == 'date'"
              class="w100"
              :class="{
                error2: input.required && !output[input.key],
              }"
              :id="getKey()"
              :style="{ width: input.width }"
              @input="runUpdate(input)"
              :required="input.required"
              v-model="output[input.key]"
              :disabled="input.disabled"
            />
            <date-picker
              v-else-if="input.type == 'date-time'"
              class="w100"
              :show-hour="true"
              :show-minute="true"
              :minute-step="15"
              :class="{
                error2: input.required && !output[input.key],
              }"
              type="datetime"
              :id="getKey()"
              :style="{ width: input.width }"
              @input="runUpdate(input)"
              :required="input.required"
              v-model="output[input.key]"
              :disabled="input.disabled"
              format="YYYY-MM-DD HH:mm"
            />
            <template
              v-else-if="
                input.type == 'price' ||
                input.type == 'money' ||
                input.type == 'quantity'
              "
            >
              <div
                class="position-absolute p-1"
                style="bottom: 0; left: 10px"
                v-if="input.allowPercent"
              >
                <i
                  v-if="output[input.key + 'Type'] == 'PERCENT'"
                  @click="
                    output[input.key + 'Type'] = 'MONEY'
                    runUpdate(input)
                  "
                  class="mdi mdi-percent font-18 text-info pointer"
                  :style="{
                    'pointer-events': input.disabled ? 'none' : 'auto',
                  }"
                />
                <i
                  v-else
                  @click="
                    output[input.key + 'Type'] = 'PERCENT'
                    output[input.key] =
                      output[input.key] > 100 ? 100 : output[input.key]
                    runUpdate(input)
                  "
                  :style="{
                    'pointer-events': input.disabled ? 'none' : 'auto',
                  }"
                  class="mdi mdi-currency-usd font-18 pointer text-primary"
                />
              </div>

              <quantity-input
                v-if="input.type == 'quantity'"
                :id="getKey()"
                :class="{
                  error: input.required && !output[input.key],
                }"
                class="form-control text-right"
                :type="input.type || 'text'"
                :placeholder="input.title"
                :required="input.required"
                :maxlength="input.maxlength || 255"
                :max="input.max"
                :min="input.min || 0"
                :minlength="input.minlength || 0"
                @input="runUpdate(input)"
                v-model="output[input.key]"
                :disabled="input.disabled"
                ref="inputs"
              />

              <money-input
                v-else
                :id="getKey()"
                class="form-control text-right"
                :class="{
                  error: input.required && !output[input.key],
                }"
                :type="input.type || 'text'"
                :placeholder="input.title"
                :required="input.required"
                :maxlength="input.maxlength || 255"
                :max="input.max"
                @input="runUpdate(input)"
                :min="input.min || 0"
                :minlength="input.minlength || 0"
                v-model="output[input.key]"
                :decimal="input.decimal || 100"
                :disabled="input.disabled"
                ref="inputs"
              />
            </template>
            <div v-else-if="input.type == 'none'" />
            <div v-else-if="input.type == 'file' || input.type == 'image'">
              <div class="d-flex align-items-start w-100 mt-3">
                <div v-if="hasSingleFileValue(input.key)" class="p-1">
                  <img
                    v-if="
                      input.type == 'image' && getImagePreviewSrc(input.key)
                    "
                    :src="getImagePreviewSrc(input.key)"
                    style="
                      width: 40px;
                      height: 40px;
                      border-radius: 6px;
                      object-fit: cover;
                    "
                  />
                  <a
                    v-else-if="getSavedFileLink(input.key)"
                    :href="getSavedFileLink(input.key)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="text-primary"
                  >
                    {{ getSelectedFileName(input.key) }}
                  </a>
                  <div
                    v-else
                    class="border round-6px px-2 py-1 bg-light"
                    style="min-width: 140px"
                  >
                    {{ getSelectedFileName(input.key) }}
                  </div>
                  <!-- <i
                    class="fa fa-times text-danger pointer"
                    style="position: absolute; top: -6px; right: -8px"
                    @click="clearSingleFile(input)"
                  /> -->
                </div>
                <label
                  class="btn btn-outline-primary mb-0 mt-2"
                  :for="'file-input-' + input.key"
                  style="flex: 1; width: auto; position: relative"
                >
                  {{ input.type == "image" ? "Chọn hình" : "Chọn file" }}
                </label>
                <input
                  :id="'file-input-' + input.key"
                  style="display: none"
                  type="file"
                  :placeholder="input.title"
                  :required="input.required && !hasSingleFileValue(input.key)"
                  :disabled="input.disabled"
                  :accept="input.type == 'image' ? 'image/*' : '*/*'"
                  @change="onSingleFileChange($event, input)"
                />
              </div>
            </div>
            <div
              v-else-if="input.type == 'files' || input.type == 'images'"
              style="width: 100%"
            >
              <input
                :id="getKey()"
                class="form-control"
                type="file"
                style="width: 100%"
                :placeholder="input.title"
                multiple
                :required="input.required"
                :disabled="input.disabled"
                @change="
                  (e) => {
                    output[input.key] = [
                      ...(output[input.key] || []),
                      ...Array.from(e.target.files),
                    ]
                    runUpdate(input)
                  }
                "
              />
            </div>
            <div v-else-if="input.type == 'time'" style="width: 100%">
              <input
                class="form-control"
                style="width: 100%; min-width: 100%"
                :value="output[input.key]"
                @input="
                  (e) => {
                    output[input.key] = e.target.value.slice(0, 5)
                    runUpdate(input)
                  }
                "
                :required="input.required"
                :disabled="input.disabled"
                type="time"
              />
            </div>
            <input
              v-else
              :id="getKey()"
              :class="{
                ['form-control ' + (input.className || '')]: true,
                error: input.required && !output[input.key],
              }"
              :type="input.type || 'text'"
              :placeholder="input.title"
              :required="input.required"
              :maxlength="input.maxlength || 255"
              :max="input.max"
              :min="input.min || 0"
              :minlength="input.minlength || 0"
              :pattern="input.pattern || input.regex"
              :step="input.step"
              :value="output[input.key]"
              @input="
                (e) => {
                  output[input.key] = applyFormat(e.target.value, input)
                  runUpdate(input)
                }
              "
              @keypress="input.onKeyPress ? input.onKeyPress($event) : null"
              :disabled="input.disabled"
              ref="inputs"
            />
            <div v-if="input.suffix" class="suffix">{{ input.suffix }}</div>
            <div
              v-if="input.info"
              v-b-tooltip="input.info"
              class="position-absolute right-4px top-30px"
            >
              <i class="mdi mdi-information-outline font-20" />
            </div>
            <p
              v-if="input.validate && input.validate(output[input.key], output)"
              class="text-danger font-12 px-3"
            >
              {{ input.validate(output[input.key], output) }}
            </p>
            <p
              v-if="validated && validated[input.key]"
              class="text-danger"
              :style="{
                position: 'absolute',
                right: '10px',
                bottom: '10px',
                fontSize: '11px',
                zIndex: 1000,
              }"
            >
              {{ validated[input.key] }}
            </p>
          </div>
        </div>
      </div>
      <div v-if="errorText" class="p-2">
        <div
          v-html="errorText"
          class="box"
          style="padding: 5px 10px; border-radius: 6px; border: 1px solid red"
        ></div>
        <!-- <p class="text-danger font-11">{{ error }}</p> -->
      </div>
      <div class="form-popup-footer mt-2" v-show="!noShowAction">
        <button
          v-if="isPopup"
          @click="$emit('onClose')"
          type="button"
          class="btn btn-basic pl-3 pr-3"
        >
          <i class="fa fa-times" />
          {{ $t("common.cancel") }}
        </button>
        <button
          :disabled="isSending"
          :class="{ warning: isWarning }"
          ref="btnSubmit"
          class="btn btn-primary ml-2 pl-3 pr-3"
          @click="onSubmit()"
        >
          <i class="fa fa-check" />
          {{ okText ? okText : $t("common.ok") }}
          <i class="fa fa-spinner fa-pulse fa-spin" v-if="isSending" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AutoComplete from "./AutoComplete.vue"
import CheckBox from "./CheckBox.vue"
import ClassicEditor from "@/components/ClassicEditor.vue"
import MultiSelectInput from "./MultiSelectInput.vue"
export default {
  components: { AutoComplete, CheckBox, ClassicEditor, MultiSelectInput },
  props: [
    "form",
    "inputs",
    "actions",
    "okText",
    "isWarning",
    "isSending",
    "noShowAction",
    "isPopup",
    "error",
    "overflow",
  ],
  name: "FromData",
  data() {
    return {
      output: {},
      URL: URL,
      validated: {},
      tabs: [],
      activeTab: "",
      errorText: "",
      filePreviewUrls: {},
      filePreviewFiles: {},
      console: console,
    }
  },
  watch: {
    output: {
      deep: true,
      handler() {
        this.errorText = ""
        this.validated = {}
        this.runUpdate()
        this.$emit("onChange", this.output)
      },
    },
    inputs() {
      this.inputs.map((i) => {
        if (i.key) {
          if (i.type == "date") {
            this.output[i.key] = new Date(i.value)
          } else {
            this.output[i.key] = i.value
          }
        }
      })
      this.tabs = [...new Set(this.inputs.map((i) => i.tab).filter((i) => i))]
      if (!this.tabs.includes(this.activeTab)) {
        this.activeTab = this.tabs[0]
      }
    },
  },
  mounted() {
    this.inputs.map((i) => {
      if (i.key) {
        if (
          i.type == "date" ||
          i.type == "date-time" ||
          i.type == "date-range"
        ) {
          this.output[i.key] = i.value ? new Date(i.value) : undefined
        } else {
          this.output[i.key] = i.value
        }
      }
    })
    this.tabs = [...new Set(this.inputs.map((i) => i.tab).filter((i) => i))]
    this.activeTab = this.tabs[0]
    this.runUpdate()
    if (this.$refs.inputs && this.$refs.inputs[0]) {
      this.$refs.inputs[0].focus()
    }
  },
  beforeDestroy() {
    Object.values(this.filePreviewUrls).map((previewUrl) => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl)
      }
      return previewUrl
    })
  },
  methods: {
    applyFormat(value, input) {
      const format = input.format
      if (!format || !value) return value
      if (format === "UPPERCASE") return value.toUpperCase()
      if (format === "LOWERCASE") return value.toLowerCase()
      if (format === "CAPITALIZE")
        return value.charAt(0).toUpperCase() + value.slice(1)
      if (format === "PHONE") {
        return value.replace(/[^0-9.+]/g, "").slice(0, 20)
      }
      return value
    },
    runUpdate(input) {
      // console.log("runUpdate", input ? input.key : "", this.output[input.key])
      if (input && input.onChange) {
        input.onChange(this.output[input.key], this.output)
      }

      this.$emit("onChange", this.output)
      this.$forceUpdate()
    },

    getValue(key) {
      return this.output[key]
    },

    getValues() {
      return this.output
    },

    getData() {
      return this.output
    },

    getKey() {
      return Math.random()
    },
    hasSingleFileValue(key) {
      return !!this.output[key]
    },
    getSavedFileLink(key) {
      return typeof this.output[key] == "string" ? this.output[key] : ""
    },
    getSelectedFileName(key) {
      const value = this.output[key]
      return value && value.name ? value.name : ""
    },
    getImagePreviewSrc(key) {
      const value = this.output[key]
      if (!value) {
        this.clearPreviewUrl(key)
        return ""
      }
      if (typeof value == "string") {
        this.clearPreviewUrl(key)
        return value
      }
      if (!(value instanceof File)) {
        this.clearPreviewUrl(key)
        return ""
      }

      const oldPreviewUrl = this.filePreviewUrls[key]
      if (oldPreviewUrl && this.filePreviewFiles[key] === value) {
        return oldPreviewUrl
      }

      this.clearPreviewUrl(key)
      const previewUrl = URL.createObjectURL(value)
      this.filePreviewUrls = {
        ...this.filePreviewUrls,
        [key]: previewUrl,
      }
      this.filePreviewFiles = {
        ...this.filePreviewFiles,
        [key]: value,
      }
      return previewUrl
    },
    clearPreviewUrl(key) {
      if (this.filePreviewUrls[key]) {
        URL.revokeObjectURL(this.filePreviewUrls[key])
        this.filePreviewUrls = {
          ...this.filePreviewUrls,
          [key]: undefined,
        }
        this.filePreviewFiles = {
          ...this.filePreviewFiles,
          [key]: undefined,
        }
      }
    },
    onSingleFileChange(event, input) {
      const file = event.target.files && event.target.files[0]
      if (!file) return
      this.output[input.key] = file
      this.runUpdate(input)
      event.target.value = ""
    },
    clearSingleFile(input) {
      this.clearPreviewUrl(input.key)
      this.output[input.key] = ""
      this.runUpdate(input)
    },
    setData(key, value) {
      if (!(value instanceof File)) {
        this.clearPreviewUrl(key)
      }
      this.output[key] = value
      this.runUpdate()
    },
    setAttr(key, type, value) {
      this.inputs.map((i) => {
        if (i.key == key) {
          i[type] = value
        }
      })
      this.runUpdate()
    },
    setAttrs(d) {
      this.inputs.map((i) => {
        const newData = d[i.key]
        if (newData) {
          Object.keys(newData).map((k) => {
            i[k] = newData[k]
          })
          if (newData.value !== undefined) {
            this.output[i.key] = newData.value
          }
        }
      })
      this.runUpdate()
    },
    reset() {
      this.inputs.map((i) => {
        if (!(i.value instanceof File)) {
          this.clearPreviewUrl(i.key)
        }
        this.output[i.key] = i.value
        this.runUpdate()
      })
    },
    ok() {
      var btn = this.$refs.btnSubmit
      btn.click()
      return this.output
    },
    validate() {
      const error = []
      this.errorText = ""
      this.inputs.map((i) => {
        if (i.required) {
          if (
            this.output[i.key] === undefined ||
            this.output[i.key] === null ||
            this.output[i.key] === "" ||
            (Array.isArray(this.output[i.key]) &&
              this.output[i.key].length == 0)
          ) {
            error.push({
              key: i.key,
              message: "Trường này là bắt buộc",
              label: i.title,
            })
          }
        }
        if (i.regex) {
          const regex = new RegExp(i.regex)
          if (this.output[i.key] && !regex.test(this.output[i.key])) {
            // error[i.key] = "Giá trị không đúng định dạng"
            error.push({
              key: i.key,
              message: "Giá trị không đúng định dạng",
              label: i.title,
            })
          }
        }
        if (i.validate) {
          const errMsg = i.validate(this.output[i.key], this.output)
          if (errMsg) {
            // error[i.key] = errMsg
            error.push({
              key: i.key,
              message: errMsg,
              label: i.title,
            })
          }
        }
      })
      if (error.length > 0) {
        // error.form = this.error
        this.errorText = `
          <p class="text-danger font-11 mb-1 bold">Vui lòng kiểm tra lại thông tin</p>
        `
        this.errorText += error
          .map(
            (e) =>
              `<p class="text-danger font-11 mb-1">${e.label}: ${e.message}</p>`,
          )
          .join("")
      }
      return error.length > 0 ? error : null
    },
    onSubmit() {
      const error = this.validate()
      if (error) {
        this.validated = error
        return
      } else {
        this.validated = {}
      }
      this.$emit("onSubmit", this.output)
    },
  },
}
</script>
